import FlightBookSidebar from 'components/Flight/Passengers/Sidebar';
import FlightBookPassengersMain from 'components/Flight/Passengers/main';
import * as S from './flightPassengers.styles';

const FlightBookPassengers = ({ discountTicketId }) => {
  return (
    <S.Wrapper>
      <S.Main>
        <FlightBookPassengersMain discountTicketId={discountTicketId} />
      </S.Main>
      <S.Sidebar>
        <FlightBookSidebar />
      </S.Sidebar>
    </S.Wrapper>
  );
};

export default FlightBookPassengers;
